import getAssignCellHandler from './getAssignCellHandler';
import getCustomColumnCellHandler from './getCustomColumnCellHandler';
import getTaskRowHoverHandler from './getTaskRowHoverHandler';
import getDndOutsideHandler from './getDndOutsideHandler';

export default instance => {
  const assignCellHandler = getAssignCellHandler(instance);
  const customColumnCellHandler = getCustomColumnCellHandler(instance);
  const taskRowHoverHandler = getTaskRowHoverHandler(instance);
  const dndOutsideHandler = getDndOutsideHandler(instance);

  instance.event(document, 'mousemove', event => {
    const taskId = instance.locate(event);

    assignCellHandler(taskId, event);
    customColumnCellHandler(taskId, event);
    taskRowHoverHandler(taskId, event);
    dndOutsideHandler(taskId, event);
  });
};
